export default {
  title: 'Modtag automatiske månedlige flyers',
  status: {
    enabled: 'Aktiveret',
    disabled: 'Deaktiveret',
  },
  opt_out: {
    on_hint:
      'Din FoodAmigos-plan inkluderer 500 gratis flyers om måneden. Slå dette fra for at stoppe med at modtage dem.',
    off_hint: 'Automatiske flyers er sat på pause. Slå til for at genoptage fra næste måneds kørsel.',
    confirm_off: {
      title: 'Slå automatiske flyers fra?',
      body: 'Hvis du slår dette fra, vil {{location}} ikke modtage automatiske flyers fra næste måneds kørsel. Eksisterende bestillinger påvirkes ikke.',
      confirm: 'Slå fra',
      cancel: 'Behold slået til',
    },
  },
  approved_design: {
    label: 'Godkendt design til månedlige flyers',
    auto_option: 'Automatisk (senest bestilte)',
    flyer_slot: 'Flyer {{slot}}',
    custom: 'Brugerdefineret',
    untitled: 'Uden titel',
    invalid_warning:
      'Det gemte design er ikke længere tilgængeligt. Den senest bestilte flyer bruges, indtil du vælger en ny.',
  },
  toasts: {
    failed_to_load: 'Indstillingerne for automatisk flyer kunne ikke indlæses',
    failed_to_save: 'Ændringerne kunne ikke gemmes',
    saved: 'Ændringer gemt',
  },
};
